import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { SegmentedControl, Toast } from 'antd-mobile';
import { getHistoryData } from './api';
import MeasurementChart from './Chart';

class ChartGroup extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      selected: 0,
      data: [],
    };
    this.handleSegmentedControlChange = this.handleSegmentedControlChange.bind(this);
    this.timeSpans = [
      { name: 'day', title: '日线' },
      { name: 'week', title: '周线' },
      { name: 'month', title: '月线' },
      { name: 'quarter', title: '季线' }, // xu_mod
    ];
    this.timeSpansTitle = this.timeSpans.map(item => item.title);
    this.fetchHistoryData = this.fetchHistoryData.bind(this);
  }

  componentDidMount() {
    this.fetchHistoryData();
  }

  async fetchHistoryData() {
    const { user, deviceId, measurement } = this.props;
    const { selected } = this.state;
    const timeSpan = this.timeSpans[selected].name;
    try {
      Toast.loading('Loading...', 0);
      const res = await getHistoryData(user, deviceId, measurement, timeSpan);
      Toast.hide();
      const { data } = res;
      this.setState({
        data: data.data,
      });
    } catch (error) {
      this.setState({
        data: [],
      });
      Toast.hide();
      if (error.response) {
        Toast.fail(error.message, 2, null, false);
      } else {
        Toast.offline(error.message, 2, null, false);
      }
    }
  }

  handleSegmentedControlChange(e) {
    this.setState({
      selected: e.nativeEvent.selectedSegmentIndex,
    }, this.fetchHistoryData);
  }

  render() {
    const { selected, data } = this.state;
    const timeSpan = this.timeSpans[selected].name;
    const { title } = this.props;

    return (
      <Fragment>
        <SegmentedControl
          values={this.timeSpansTitle}
          onChange={this.handleSegmentedControlChange}
          selectedIndex={selected}
        />
        <MeasurementChart data={data} timeSpan={timeSpan} title={title} />
      </Fragment>
    );
  }
}

ChartGroup.propTypes = {
  user: PropTypes.string.isRequired,
  deviceId: PropTypes.string.isRequired,
  measurement: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ChartGroup;
